import { render, staticRenderFns } from "./CtrlAddFromListBtn.vue?vue&type=template&id=58bf6c42&scoped=true&"
import script from "./CtrlAddFromListBtn.vue?vue&type=script&lang=ts&"
export * from "./CtrlAddFromListBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf6c42",
  null
  
)

export default component.exports